<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-6"><a href="#/OEBPS/A_Few_Right_Thinking_Men2#Contents-A">Crime Wave</a></p>
<p class="article-head">Brutal Murder</p>
<p class="article-date">SYDNEY, Thursday</p>
<p class="article-body">Late last night, police attended a shocking murder scene at one of Sydney’s foremost suburbs.</p>
<p class="article-body1">The deceased gentleman, Mr. Rowland Sinclair, died in his own home, after or during a brutal attack by unknown assailants. Authorities were alerted by his housekeeper who discovered his bludgeoned body. The victim was from one of the State’s pre-eminent families: the Sinclairs of Oaklea near Yass.</p>
<p class="article-body1">It is a sign of the times that the lawlessness that has taken hold of Sydney’s streets has invaded the homes of even the most well-to-do. Violent crime, on the rise since the Great War, has been further exacerbated by the current political tensions, as well as the ever-mounting numbers of unemployed. Burglaries and robberies from the person, often with firearms and violence, are now daily events, with the meanest classes of thefts reported from all quarters. Last evening was no exception.</p>
<p class="article-body1">According to police sources, Mr. Sinclair’s attackers were merciless. The investigation is continuing, though Superintendent MacKay was not available for comment.</p>
<p class="article-body1">Superintendent MacKay has come to prominence for his efforts to suppress the Razor Gangs waging their murderous warfare in Sydney’s streets and terrorising honest citizens.</p>
<p class="article-body1">Colonel Eric Campbell, the Commander of the New Guard, attributes the current crime wave to Communist elements conspiring to destabilise the State. Last night, he again offered the assistance of his men to the State Police Force.</p>
<p class="article-body1">Colonel Michael Bruxner, of the newly formed United Country Party, and a friend of the Sinclair family, paid tribute to Mr. Sinclair before calling upon Premier Lang to urgently address the rampant crime facing the citizens of Sydney. “People can no longer feel safe in their homes,” he said.</p>
<p class="article-body2"><span class="italic1">The Sydney Morning Herald</span>, <br class="calibre3"/>December 11, 1931</p>
<p class="article-body2"></p>
<p class="article-body2"><span><img alt="Image29402.JPG" class="frame1" src="OEBPS/image/Image29402_fmt.png"/></span></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Few_Right_Thinking_Men-5.vue?01e4583c